import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

interface ProtectedRouteProps {
  children: ReactNode;
  permission?: string;
  adminOnly?: boolean;
}

export default function ProtectedRoute({ children, permission, adminOnly }: ProtectedRouteProps) {
  const { user } = useAuth();

  // 管理者専用ページのチェック
  if (adminOnly && user?.roleCode !== 'admin') {
    return <Navigate to="/dashboard" replace />;
  }

  // 権限チェック
  if (permission && user?.permissions && !user.permissions.includes(permission)) {
    return (
      <div className="flex flex-col items-center justify-center h-64">
        <div className="text-6xl mb-4">🚫</div>
        <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-2">アクセス権限がありません</h2>
        <p className="text-gray-500">このページを表示する権限がありません。</p>
      </div>
    );
  }

  return <>{children}</>;
}
